import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { PersistGate } from 'redux-persist/integration/react';
import NetworkError from './components/Modal/NetworkError';
import RouteObserver from './components/RouteObserver';
import { IframePaymentProvider } from './contexts/IframePaymentContext';
import Routes from './routes';
import { persistor, store } from './store';
import ConnectedThemeProvider from './styles/ConnectedThemeProvider';
import GlobalStyle from './styles/global';

const App: React.FC = () => {
  const [networkError, setNetworkError] = React.useState(false);
  const [error, setError] = React.useState(false);
  const [contactsError, setContactsError] = React.useState<string | undefined>(
    undefined
  );

  store.subscribe(() => {
    setNetworkError(
      ((store.getState() as unknown) as ApplicationState).error.networkError
    );
    setError(((store.getState() as unknown) as ApplicationState).error.error);
    setContactsError(
      ((store.getState() as unknown) as ApplicationState).contactsByCpf?.error
    );
  });

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ConnectedThemeProvider>
          {networkError && <NetworkError />}
          <Router>
            <IframePaymentProvider>
              {error && (
                <Redirect to={{ pathname: '/erro', state: contactsError }} />
              )}
              <Routes />
              <GlobalStyle />
              <ToastContainer
                closeButton={false}
                autoClose={5000}
                hideProgressBar={true}
              />
              <RouteObserver />
            </IframePaymentProvider>
          </Router>
        </ConnectedThemeProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
